<template>
  <div
    :style="{
      backgroundImage:
        'url(' + (activeInfo.actScreenImg && activeInfo.actScreenImg) + ')',
      backgroundSize: 'cover',
    }"
    class="bg"
  >
    <!-- <vue-seamless-scroll
      :data="showList"
      class="winners-list-cont"
      :class-option="classOption"
      style="text-align: center"
    > -->
    <div class="winner">
      <ul id="winners">
        <li v-for="(item, index) of showList" :key="index">
          <div>
            <div>
              <img
                alt
                :src="
                  item.queSource === 1
                    ? require('../assets/img/54a9ec7ed8df8.jpg')
                    : require('../assets/img/20150629193341_FMTv2.jpeg')
                "
              /><span style="padding-left: 20px; color: orange">{{
                item.createTime && item.createTime.substring(0, 19)
              }}</span>
            </div>
            <div class="content">
              <span>{{ item.queContent }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- </vue-seamless-scroll> -->
  </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  data() {
    return {
      showList: [],
      actId: 0,
      lasttime: '',
      activeInfo: {},
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.showList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 20, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        lasttime: '',
      }
    },
  },
  created() {
    var url = window.location.href
    var cs = url.split('?')[1] //?后面的参数字符串
    var cs_arr = cs.split('&') //将参数字符串分割为包含多个参数的数组
    var cs = {} //声明一个容器
    for (var i = 0; i < cs_arr.length; i++) {
      //遍历数组
      cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }
    this.actId = cs.actId
    this.getActiveInfo()
    this.getDataList()

    this.getList()
  },
  components: {
    vueSeamlessScroll,
  },
  mounted() {
    this.scrollToBottom()
  },
  updated: function () {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        var div = document.getElementById('winners')
        window.scrollTo(0, div.scrollHeight)
      })
    },
    getList() {
      setInterval(() => {
        this.getDataList()
      }, 1000)
    },
    getActiveInfo() {
      this.$http({
        url: `/act/activity/info/${this.actId}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.activeInfo = data.data
        }
      })
    },
    getDataList() {
      this.$http({
        url: '/act/questions/screenDisplay',
        method: 'get',
        params: {
          actId: this.actId,
          lasttime: this.lasttime,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.data.list.length > 0) {
            this.showList = this.showList.concat(data.data.list)
            this.lasttime = data.data.lasttime
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.bg {
  min-height: 100vh;
}
.content {
  background: #eee;
  margin-left: 60px;
  padding: 20px;
  border-radius: 10px;
  // border: 2px solid rgb(183, 236, 245);
  box-shadow: #666 0px 0px 5px 2px;
  font-size: 20px;
}
ul li {
  list-style: none;
  width: 1000px;
  min-height: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 30px;
}
ul li img {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: inline;
}
.winners-list-cont {
  height: 100%;
  overflow: hidden;
  margin: 50px;
}
.winner {
  height: 100%;
  overflow: hidden;
  position: relative;
  margin-left: 50px;
}
</style>